export default {
  headerContent: {
    title: 'Ray Sigorta Tamamlayıcı Sağlık Sigortası Teklifi',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Ray Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Ray Sigorta Tamamlayan Sağlık Sigortası; sosyal güvencesi bulunan bireylerin özel hastanelerde tedavi hizmeti almalarını sağlamaktadır.',
        'Ray Sigorta tamamlayıcı sağlık sigortası SGK ile anlaşmalı özel hastaneler kaza veya hastalık sonucu alınması gereken tedavi hizmeti sonucunda oluşan maddi giderlere karşı koruma sağlamaktadır.',
        'Tamamlayan Sağlık Sigortası ayakta ve yatarak tedavi teminatlarına ek olarak, ücretsiz check-up ve diş sağlığı paketini de sigortalılarına sunmaktadır.'
      ]
    },
    subContent: {
      title: 'Ray Sigorta Tamamlayıcı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası teminatları yatarak, ayakta ve doğum (annelik teminatı) olmak üzere 3’e ayrılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Acil ulaşım Ambulans',
            'Ameliyat',
            'Evde Bakım',
            'Hastanede tedavi',
            'Kemoterapi, Radyoterapi',
            'Oda / Yemek/ Refakatçi',
            'Suni uzuv',
            'Tıbbi malzeme'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Ayakta Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Doktor Muayene',
            'Laboratuvar',
            'İleri tanı yöntemleri',
            'Radyoloji',
            'Fizik Tedavi'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Ray Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
